import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';

import { getData, postData } from '../lib/utils';
import { Context } from "../components/contexts/AppContext";

const ChooseYourPlan = () => {

  const navigate = useNavigate();

  const { value } = useContext(Context);
  const [appState, setAppState] = value; 

  

  useEffect(() => {

    const fetchData = async () => {
      try {

        const response = await getData("admin/admin-details");

        setAppState((prevState) => ({
          ...prevState,
          adminDetails: response.admin,
        }));

      } catch (error) {
        console.error("Error fetching admin details:", error);
      }
    };

    const token = localStorage.getItem('authToken');

    if (token === null) {
      navigate("/login");
    } else {
      fetchData();
    }

  }, []);

  // =========================
  // HANDLE PAYMENT STRIPE
  // =========================
  const handlePlanClick = async (planName, featureOption = null) => {

    try {
      
 
      // ✅ STRIPE
      const stripePromise = loadStripe(JSON.stringify(process.env.REACT_APP_STRIPE_SECRET_TEST_KEY, null, 2));

      const stripe = await stripePromise;

      if (!stripe) {
        alert("Stripe failed to load.");
        return;
      }

      let requestBody = {
        name: planName,
        currency: 'usd',
        email: appState.adminDetails.email,
        userId: appState.adminDetails.id,
      };

      // =========================
      // ON DEMAND PLAN
      // =========================
      if (featureOption) {

        const storageGB = parseInt(featureOption.storage);
        const price = parseInt(featureOption.price) * 100;

        requestBody = {
          ...requestBody,
          credits: storageGB * 1024,
          description: `${featureOption.storage} Upload Pack`,
          price,
          mode: "payment",
        };
      }

      // API CALL
      const response = await postData(
        "admin/makepayment",
        requestBody
      );

      // REDIRECT TO STRIPE
      if (response?.url) {

        window.location.href = response.url;

      } else {

        alert("Stripe session creation failed.");
      }

    } catch (err) {

      console.error("Payment initiation failed", err);

      alert("Something went wrong while initiating payment.");
    }
  };



  const loadRazorpay = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");

    script.src = "https://checkout.razorpay.com/v1/checkout.js";

    script.onload = () => {
      resolve(true);
    };

    script.onerror = () => {
      resolve(false);
    };

    document.body.appendChild(script);
  });
};

  // =========================
  // HANDLE PAYMENT RAZORPAY INDIA Only
  // =========================
  const handleIndiaPlanClick = async (
  planName,
  featureOption = null
) => {

  try {

    // 1. Backend se Razorpay order create karwao

    const order = await postData(
      "admin/create-order",
      {
        amount: parseInt(featureOption.price)
      }
    );

    // 2. Razorpay popup open karo

    const options = {

      key: process.env.REACT_APP_RAZORPAY_KEY_ID,

      amount: order.amount,

      currency: order.currency,

      name: "VidMantra",

        method: {
    upi: true,
    card: true,
    netbanking: false,
    wallet: false,
    emi: false,
    paylater: false
  },

      description:
        featureOption.storage + " GB Storage",

      order_id: order.id,

      prefill: {
        email: appState.adminDetails.email,
      },

      handler: async function (response) {

        const verify = await postData(
          "admin/verify-payment",
          {
            razorpay_order_id:
              response.razorpay_order_id,

            razorpay_payment_id:
              response.razorpay_payment_id,

            razorpay_signature:
              response.razorpay_signature,

            userId:
              appState.adminDetails.id,

            credits:
              parseInt(featureOption.storage) * 1024
          }
        );


        console.log("VVVVVVVVVVVVVV ",verify)

        if (verify?.success) {

          alert("Payment Successful");

        } else {

          alert("Verification Failed");
        }
      }
    };

    console.log("OPtIONS  ", options)
    
    const res = await loadRazorpay();

if (!res) {
  alert("Razorpay SDK failed to load");
  return;
}


    const rzp =
      new window.Razorpay(options);

    rzp.open();

  } catch (err) {

    console.log(err);

    alert("Payment failed");
  }
};

  // =========================
  // PLANS
  // =========================
// =========================
// PLANS
// =========================
const planTabs = {
  quarterly: [
    { photoLimit: 20000/4, price: 999 },
    { photoLimit: 50000/4, price: 1499 },
    { photoLimit: 100000/4, price: 1999 },
    { photoLimit: 125000/4, price: 2499 },
    { photoLimit: 150000/4, price: 3499 },
    { photoLimit: 200000/4, price: 3999 },
    { photoLimit: 250000/4, price: 4999 },
    { photoLimit: 300000/4, price: 5999 },
    { photoLimit: 350000/4, price: 6999 },
    { photoLimit: 500000/4, price: 7999 },
  ],

  halfYearly: [
    { photoLimit: 20000/2, price: 1999 },
    { photoLimit: 50000/2, price: 2999 },
    { photoLimit: 100000/2, price: 3999 },
    { photoLimit: 125000/2, price: 4999 },
    { photoLimit: 150000/2, price: 6999 },
    { photoLimit: 200000/2, price: 7999 },
    { photoLimit: 250000/2, price: 9999 },
    { photoLimit: 300000/2, price: 11999 },
    { photoLimit: 350000/2, price: 13999 },
    { photoLimit: 500000/2, price: 15999 },
  ],

  yearly: [
    { photoLimit: 20000, price: 3999 },
    { photoLimit: 50000, price: 5499 },
    { photoLimit: 100000, price: 7999 },
    { photoLimit: 125000, price: 8999 },
    { photoLimit: 150000, price: 13999 },
    { photoLimit: 200000, price: 15999 },
    { photoLimit: 250000, price: 19999 },
    { photoLimit: 300000, price: 23999 },
    { photoLimit: 350000, price: 27999 },
    { photoLimit: 500000, price: 31999 },
  ],
};
const [activeTab, setActiveTab] = useState("quarterly");

  return (

    <section className="h-[calc(100vh-80px)] bg-black text-white py-10 px-4 overflow-auto">

      {/* HEADER */}
      <div className="max-w-6xl mx-auto text-center mb-4">

        <h1 className="text-3xl md:text-4xl font-bold mb-3">
          Choose Your Upload Pack
        </h1>

        <div className="flex justify-center mb-8">
  <div className="bg-[#111] p-1 rounded-xl flex">
    
    <button
      onClick={() => setActiveTab("quaterly")}
      className={`px-6 py-2 rounded-lg ${
        activeTab === "quaterly"
          ? "bg-yellow-500 text-black"
          : "text-white"
      }`}
    >
      quaterly
    </button>

    <button
      onClick={() => setActiveTab("halfYearly")}
      className={`px-6 py-2 rounded-lg ${
        activeTab === "halfYearly"
          ? "bg-yellow-500 text-black"
          : "text-white"
      }`}
    >
      Half Yearly
    </button>

    <button
      onClick={() => setActiveTab("yearly")}
      className={`px-6 py-2 rounded-lg ${
        activeTab === "yearly"
          ? "bg-yellow-500 text-black"
          : "text-white"
      }`}
    >
      Yearly
    </button>

  </div>
</div>
        <p className="text-gray-400 text-sm md:text-base max-w-2xl mx-auto">
          Flexible upload storage with no quaterly subscription.
        </p>

        {
          appState?.adminDetails?.name && (
            <div className="mt-4 text-yellow-400 text-lg font-medium">
              Welcome back, {appState.adminDetails.name}
            </div>
          )
        }

      </div>

      {/* PLANS */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-5 max-w-6xl mx-auto">

        {
          planTabs?.[activeTab]?.map((plan, idx) => (

            <div
              key={idx}
              className={`
                relative rounded-2xl border p-6 bg-[#111111]
                transition-all duration-300 hover:-translate-y-1

                ${
                  plan.popular
                    ? 'border-yellow-500 shadow-lg shadow-yellow-500/10'
                    : 'border-gray-800'
                }
              `}
            >

              {/* BADGE */}
              {
                plan.popular && (
                  <div className="absolute top-4 right-4 bg-yellow-500 text-black text-[10px] font-bold px-3 py-1 rounded-full">
                    Popular
                  </div>
                )
              }

              {
                plan.value && (
                  <div className="absolute top-4 right-4 bg-green-500 text-black text-[10px] font-bold px-3 py-1 rounded-full">
                    Best Value
                  </div>
                )
              }

              {/* STORAGE */}
              <div className="mb-5">

              <div className="text-4xl font-bold">
  {(plan.photoLimit / 1000).toFixed(0)}K
</div>

<div className="text-yellow-400 text-sm mt-1">
  Photo Upload Limit
</div>

                <div className="text-yellow-400 text-sm mt-1">
                   {(plan.photoLimit*2).toLocaleString()} Photos
                </div>

              </div>

              {/* PRICE */}
              <div className="mb-2">

                <span className="text-3xl font-bold">
                  ₹{plan.price}
                </span>

              </div>

              {/* RATE */}
          <div className="text-gray-400 text-sm mb-6">
  {activeTab === "quarterly"
    ? "90 Days"
    : activeTab === "halfYearly"
    ? "180 Days"
    : "360 Days"}
</div>

              {/* FEATURES */}
              <div className="space-y-2 mb-6 text-sm">

                

                <div className="flex items-center gap-2">
                  <span className="text-green-400">✔</span>
                  <span className="text-gray-300">
                    AI Face Search
                  </span>
                </div>
                  <div className="flex items-center gap-2">
                  <span className="text-green-400">✔</span>
                  <span className="text-gray-300">
                    Watermark On/Off
                  </span>
                </div>
                  <div className="flex items-center gap-2">
                  <span className="text-green-400">✔</span>
                  <span className="text-gray-300">
                    Brand Buildling
                  </span>
                </div>
                  <div className="flex items-center gap-2">
                  <span className="text-green-400">✔</span>
                  <span className="text-gray-300">
                   Download On/Off
                  </span>
                </div>

                <div className="flex items-center gap-2">
                  <span className="text-green-400">✔</span>
                  <span className="text-gray-300">
                    Secure Storage
                  </span>
                </div>

              </div>

              {/* BUTTON */}
    <button
  onClick={() =>
    handleIndiaPlanClick("Image Only", {
      ...plan,
      billingCycle: activeTab,
    })
  }
  className="w-full rounded-xl py-3 bg-yellow-500 text-black font-semibold hover:bg-yellow-400"
>
  Buy Plan
</button>

            </div>
          ))
        }

      </div>

 

    </section>
  );
};

export default ChooseYourPlan;